import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export function createControls(camera, renderer) {
  const orbit = new OrbitControls(camera, renderer.domElement);

  // Keep camera motion deterministic so tracer resets happen at the final pose,
  // not throughout a damping settle phase.
  orbit.enableDamping = false;
  orbit.enablePan = false;
  orbit.minDistance = 1.35;
  orbit.maxDistance = 3.9;
  orbit.minPolarAngle = Math.PI / 6;
  orbit.maxPolarAngle = (Math.PI * 5) / 6;
  orbit.rotateSpeed = 0.45;
  orbit.zoomSpeed = 0.8;
  orbit.update();

  return orbit;
}
